import type { ReactNode } from 'react';

export const symbol_bookmark_heart: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-648q-12-15-31-23.5t-41-8.5q-36 0-62 26t-26 62q0 19 5.5 35t22.5 38q15 20 41.5 46t68.5 65q5 5 10.56 6.5 5.57 1.5 11.5 1.5 5.94 0 11.44-1.5Q497-403 502-408q42-38 68.17-63.94Q596.34-497.88 611-518q17-22 23-38.5t6-35.5q0-36-26-62t-62-26q-21 0-40.5 8.5T480-648Zm0 408-196 84q-30 13-57-4.76-27-17.75-27-50.24v-574q0-24 18-42t42-18h440q24 0 42 18t18 42v574q0 32.49-27 50.24Q706-143 676-156l-196-84Zm0-64 220 93v-574H260v574l220-93Zm0-481H260h440-220Z"
		/>
	</svg>
);
